import type { Template } from '../types';
import { sealedDark } from './sealedDark';

/* The registry. A new template is a file next to this one and a line
   here; the editor builds its form from the template's own field list,
   and the API stores whatever it produces. */

export const TEMPLATES: Template[] = [sealedDark];

export const DEFAULT_TEMPLATE = sealedDark.id;

export function templateById(id: string): Template {
  return TEMPLATES.find((t) => t.id === id) ?? sealedDark;
}
